import * as React from 'react'
import './styles.css'
// components
import Form from './components/Form'
// constants
import {
  REQUIRED_CHECK_STRING,
  REQUIRED_PASSWORD,
} from '../../../../../constants/mwm'

const PasswordCheck = ({ checkPassword }) => {
  const [submitError, setSubmitError] = React.useState(false)

  const onSubmit = async (data) => {
    try {
      const password = data.password

      if (password === REQUIRED_PASSWORD) {
        localStorage.setItem('isPasswordMatched', REQUIRED_CHECK_STRING)
        checkPassword()
      } else {
        throw new Error('Passwords do not match')
      }
    } catch (error) {
      setSubmitError(true)
    }
  }

  return (
    <section className={'password-check-wrapper'}>
      <div className={'password-check-content'}>
        <div className={'password-check-title-container'}>
          <h1 className={'password-check-title'}>Password Required</h1>
          <p className={'password-check-description'}>
            Please enter the password required to view this page.
          </p>
        </div>
        <Form onSubmit={onSubmit} submitError={submitError} />
      </div>
    </section>
  )
}

export default PasswordCheck
